import { gql } from '@apollo/client';

export const typeOptions = [
  { value: 'ACO - Process Documents', label: 'ACO - Process Documents' },
  { value: 'ACO - Report', label: 'ACO - Report' },
  { value: 'Adjournment - Request/Motion', label: 'Adjournment - Request/Motion' },
  { value: 'Adjournment - Process Documents', label: 'Adjournment - Process Documents' },
  { value: 'Adjournment - Decision', label: 'Adjournment - Decision' },
  { value: 'Advance Funds - Request', label: 'Advance Funds - Request' },
  { value: 'Advance Funds - Process Document', label: 'Advance Funds - Process Document' },
  { value: 'Advance Funds - Decision', label: 'Advance Funds - Decision' },
  { value: 'Application Materials', label: 'Application Materials' },
  { value: 'CHC Letter', label: 'CHC Letter' },
  { value: 'Confidentiality - Request', label: 'Confidentiality - Request' },
  { value: 'Confidentiality - Process Documents', label: 'Confidentiality - Process Documents' },
  { value: 'Confidentiality - Decision', label: 'Confidentiality - Decision' },
  { value: 'Confidential Undertaking', label: 'Confidential Undertaking' },
  { value: 'Decision - Cancelled Hearing', label: 'Decision - Cancelled Hearing' },
  { value: 'Decision - Hearing Held', label: 'Decision - Hearing Held' },
  { value: 'Information Request, Response, etc.', label: 'Information Request, Response, etc.' },
  { value: 'Interim Costs - Request', label: 'Interim Costs - Request' },
  { value: 'Interim Costs - Process Documents', label: 'Interim Costs - Process Documents' },
  { value: 'Interim Costs - Decision', label: 'Interim Costs - Decision' },
  { value: 'Motion - Filed', label: 'Motion - Filed' },
  { value: 'Motion - Process Documents', label: 'Motion - Process Documents' },
  { value: 'Motion - Decision', label: 'Motion - Decision' },
  { value: 'NQCL - Filed', label: 'NQCL - Filed' },
  { value: 'NQCL - Process Documents', label: 'NQCL - Process Documents' },
  { value: 'NQCL - Decision', label: 'NQCL - Decision' },
  { value: 'Notice of Adjournment', label: 'Notice of Adjournment' },
  { value: 'Notice of Cancelled Hearing', label: 'Notice of Cancelled Hearing' },
  { value: 'Notice of Hearing', label: 'Notice of Hearing' },
  { value: 'Notice of Hearing - Amended', label: 'Notice of Hearing - Amended' },
  { value: 'Notice of Scheduling of Hearing', label: 'Notice of Scheduling of Hearing' },
  {
    value: 'Notice of Scheduling of Hearing - Amended',
    label: 'Notice of Scheduling of Hearing - Amended',
  },
  { value: 'Notice - Other', label: 'Notice - Other' },
  { value: 'Other', label: 'Other' },
  { value: 'Participation - Request', label: 'Participation - Request' },
  { value: 'Participation - Process Documents', label: 'Participation - Process Documents' },
  { value: 'Participation - Decision', label: 'Participation - Decision' },
  { value: 'Procedural Decision - Other', label: 'Procedural Decision - Other' },
  { value: 'Record of Decision Maker - Requested', label: 'Record of Decision Maker - Requested' },
  {
    value: 'Record of Decision Maker - Process Documents',
    label: 'Record of Decision Maker - Process Documents',
  },
  { value: 'Record of Decision Maker - Received', label: 'Record of Decision Maker - Received' },
  {
    value: 'Record for Reconsideration - Requested',
    label: 'Record for Reconsideration - Requested',
  },
  {
    value: 'Record for Reconsideration - Process Documents',
    label: 'Record for Reconsideration - Process Documents',
  },
  {
    value: 'Record for Reconsideration - Received',
    label: 'Record for Reconsideration - Received',
  },
  {
    value: 'Submission (pursuant to submission schedule)',
    label: 'Submission (pursuant to submission schedule)',
  },
  { value: 'Transcripts', label: 'Transcripts' },
];

export const additionalOptions = [
  { value: 'Hearing Panel', label: 'Hearing Panel' },
  { value: 'Other', label: 'Other' },
];

export const GET_ALL_FILES = gql`
  query Data($input: String) {
    dataFiles(input: $input) {
      data {
        key
        securityClassification
        id
        attachmentId
        exhibitNumber
        type
        actualRecievedOrSentDate
        comments
        participantId
        fileName
        participantName
        otherSubmitter
        otherSubmitter
        dateMaterialRequested
        dateMaterialReceivedFromBranch
        dateMaterialsSentToCompanyForValidation
        dateCompanyCompletedValidation
        dateEvidentiaryPortionOfHearingClosed
        IRStartDate
        IREndDate
        originalExhibitFromLegacy
        size
      }
      exhibitNumbers
    }
  }
`;

export const formatFileSize = (bytes: number) => {
  const sizes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  const i: number = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
};

export const UPDATE_DATA_FILE = gql`
  mutation EditDataFile($input: EditDataFile) {
    editDataFile(input: $input) {
      result
    }
  }
`;

export const SEARCH_IN_DOCUMENTS_QUERY = gql`
  query SearchDocument($input: DocumentFilter) {
    searchDocument(input: $input) {
      data {
        proceedingNumber
        fileName
        exhibitNumber
        contentPreview
        type
        contentType
        otherSubmitter
        participantId
        participantName
        originalExhibitFromLegacy
        key
        securityClassification
        comments
        actualRecievedOrSentDate
        id
        size
      }
    }
  }
`;
